module.exports = __webpack_public_path__ + "img/profitability3.b2577ad0.png";